<template>
    <div>

        <v-form v-model="valid" ref="formData">

            <v-dialog v-model="dialogPayment" persistent width="50%">
                <v-overlay :value="overlay">
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>

                <v-card>
                    <v-card-title>
                        <span>{{ $t("payment") }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            text
                            icon
                            @click="handleClose"
                            valid="false"
                            v-shortkey="['esc']"
                            @shortkey.native="handleClose"
                        >
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="seperate-line-verticle">

                                <v-row style="padding-right: 10px">

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.client_name"
                                            outlined
                                            dense
                                            :label="$t('client')"
                                            disabled
                                        ></v-text-field>
                                      
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.supplier_name"
                                            outlined
                                            dense
                                            :label="$t('supplier')"
                                            disabled
                                        ></v-text-field>
                                      
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            v-model="formPayment.currency_code"
                                            :items="currencyOptionList"
                                            disabled
                                            :label="$t('currency')"
                                            outlined
                                            item-text="text"
                                            item-value="id"
                                            dense
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            :items="wallet_accounts"
                                            :label="$t('paymentMethod')"
                                            outlined
                                            v-model="formPayment.wallet_account"
                                            dense
                                            :rules="selectRules"
                                            required
                                            item-text="value"
                                            item-value="id"
                                        >
                                            <template v-slot:selection="{ item }">{{ $t(item.id) }}</template>
                                            <template v-slot:item="{ item }">{{ $t(item.id) }}</template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            v-model="formPayment.supplier_account_type"
                                            :items="supplier_wallets"
                                            outlined
                                            :dense="dense"
                                            item-text="company_name"
                                            item-value="account_type"
                                            :label="$t('receiverPayment') + '*'"
                                            :rules="selectRules"
                                            required
                                        ></v-select>
                                    </v-col>

                                     <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.available_balance"
                                            outlined
                                            dense
                                            :label="$t('balance')"
                                            disabled
                                            :suffix="getCurrencySymbol(formPayment.currency_code)"
                                        ></v-text-field>
                                    </v-col>


                                    <v-col cols="12" sm="12" md="12">
                                        <v-menu
                                            v-model="menuDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="formPayment.date"
                                                    :label="$t('receivePaymentDate') + '*'"
                                                    prepend-inner-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    readonly
                                                    :rules="dateRules"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :first-day-of-week="0"
                                                v-model="formPayment.date"
                                                :rules="dateRules"
                                                @input="menuDate = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.reference"
                                            outlined
                                            dense
                                            :label="$t('reference')"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-row>
                                    <v-col cols="5" sm="5">{{ $t("totalAmount") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_payment | formatNumber}} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paid") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.complete_paid | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("partial") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.due_amount | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("percentage") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ calculatePercentage }}%</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paidAmount") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="formPayment.paid_amount"
                                            outlined
                                            dense
                                            :max="formPayment.total_payment"
                                            min="1"
                                            style="margin-bottom: -10px"
                                            required
                                            :rules="requireAndNumberAtleaseOne"
                                            >
                                        </v-text-field>
                                        <span v-show="! this.valid_paid" class="error--text">{{ $t('maximum') + ' ' + formPayment.total_payment }} </span>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea
                                            clearable
                                            outlined
                                            :placeholder="$t('yourDesc')"
                                            v-model="formPayment.note"
                                            clear-icon="mdi-close-circle"
                                            rows="3"
                                            auto-grow
                                            :label="$t('note')"
                                        ></v-textarea>
                                    </v-col>

                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            rounded
                            @click="submitPayment($event,true)"
                            style="min-width: 150px"
                            color="primary"
                            :disabled="! this.valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("payAndPrint")}}
                        </v-btn>
                        <v-btn
                            rounded
                            @click="submitPayment($event)"
                            style="min-width: 150px"
                            color="success"
                            :disabled="! this.valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("proceedPay")}}

                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>

        </v-form>

    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";


    export default {
        name: "buybackPaymentSale",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {
                valid_paid: true,
                wallet_accounts: [],
                supplier_wallets: [],

                formPayment: {
                    id: '',
                    reference: "",
                    client_id: "",
                    client_name:"",
                    name_name:"",
                    supplier_id: "",
                    supplier_account_type: "",
                    supplier_account_no: "",
                    currency_code: "",
                    note: '',
                    date: moment().format("YYYY-MM-DD"),
                    total_payment: "",
                    paid_amount: "",
                    wallet_account: "",
                    available_balance: 0,
                    transaction_id: "",
                    transaction_payment_term_id: "",
                    percentage: "100",
                    complete_paid: 0
                },

            };
        },

        methods: {
            
            reset() {
                if(this.$refs.formData){
                    this.$refs.formData.reset();
                    this.formPayment.date = '';
                    this.formPayment.paid_amount = 0;
                    this.formPayment.total_payment= 0;
                    this.formPayment.complete_paid = 0;
                }
            },

            handleClose(){
                this.$store.dispatch('updateBuybackDialogPayment', {dialog_sale: false, transaction_id: '', client_id: ''});
            },

            submitPayment(event, isPrint) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {

                    if(+this.formPayment.available_balance < +this.formPayment.paid_amount){
                        vm.$notify({
                            title: "Error",
                            message: vm.$t("walletNotEnough"),
                            type: "error",
                            duration: 2000
                        });
                        return true;
                    }

                    vm.overlay = true;
                    let url = provider.baseURL + provider.storeInvoicePayment;
                    return new Promise((resolve, reject) => {
                        axios.post(url, this.formPayment, {headers: {Authorization: localStorage.token}}).then(
                            res => {
                                if (res.data.response && res.data.response.code === 200) {
                                    resolve(res.data.data.payment_transaction_id);
                                    vm.$notify({
                                        title: "Success",
                                        message: vm.$t("success"),
                                        type: "success",
                                        duration: 700
                                    });
                                    vm.dialog = false;
                                    if (isPrint === true) {
                                        vm.$router.push({name: 'beeshop.buyback.buyback-trading.payment-receipt-vourcher-print', params: { id: res.data.data.payment_transaction_id, type: "Invoice"}})
                                    }
                                    vm.overlay = false;
                                    vm.$store.dispatch('updateBuybackDialogPayment', {dialog_sale: false, transaction_id: '', client_id: ''});
                                }
                                else{
                                    vm.$notify({
                                        title: "Error",
                                        message: res.data.response.message,
                                        type: "error",
                                        duration: 2000
                                    });
                                    vm.overlay = false;
                                }
                            },
                            error => {
                                reject(error);
                                vm.overlay = false;

                            }

                        );
                    });

                }
            },

        },

        watch: {
            dialogPayment(val) {
                if (val === false) { this.reset(); }
                else {
                    this.fetchCurrencyOption();
                }
            },

            async transaction_id(transaction_id){
                if(transaction_id && this.dialogPayment){
                    /** Fetch the payment terms */
                    let vm = this;
                    this.formPayment.date = moment().format("YYYY-MM-DD");
                    this.overlay = true;

                    let url = provider.baseURL + provider.fetchDueInvoicePaymentDetail;

                    await axios.post(url, {transaction_id: transaction_id}, {headers: {Authorization: localStorage.token}}).then(res => {
                        if (res.data.response && res.data.response.code === 200) {
                            let data = res.data.data;

                            vm.formPayment.client_id           = data.client[0].client_id;
                            vm.formPayment.client_name         = data.client[0].client_name;
                            vm.formPayment.transaction_id      = data.transaction_id;
                            vm.formPayment.transaction_payment_term_id = data.transaction_payment_term_id;
                            vm.formPayment.supplier_name       = data.supplier[0].supplier_name;
                            vm.formPayment.supplier_id         = data.supplier[0].supplier_id;
                            vm.formPayment.total_payment       = data.total_amount;
                            vm.formPayment.paid_amount         = data.due_amount;
                            vm.formPayment.complete_paid       = data.paid_amount;
                            vm.formPayment.due_amount          = data.due_amount;
                            vm.formPayment.percentage          = data.percentage;
                            vm.formPayment.currency_code       = data.currency[0].currency_code;
                            vm.wallet_accounts                 = data.wallet_account;
                            vm.supplier_wallets                = data.supplier_wallet;
                            vm.overlay = false;
                        }   
                    }).catch(error => {
                        vm.overlay = false;
                        console.log(error)
                    });
                }
            },

            "formPayment.paid_amount"(val){
                let paid_amount  = +val;
                let total_payment = this.formPayment.total_payment;
                if(paid_amount > total_payment){
                    this.valid_paid = false;
                }
                else{
                    this.valid_paid = true;
                }
            },

            "formPayment.wallet_account"(val){

              console.log(this.wallet_accounts);
                let account_payment = this.wallet_accounts.filter(obj => {
                    return obj.id == val;
                });

                if(account_payment.length){
                    account_payment = account_payment[0];
                    this.formPayment.available_balance  = +account_payment.balance;
                  //  this.formPayment.supplier_account_no= account_payment.account_no;
                }
            },

            "formPayment.supplier_account_type"(val){
                let wallet = this.supplier_wallets.filter(obj => {
                    return obj.account_type == val;
                });

                if(wallet.length){
                    wallet = wallet[0];
                    this.formPayment.supplier_account_no = wallet.account_no;
                }
            },

        },
        computed: {
            calculatePercentage(){
                let per = (+this.formPayment.total_payment - +this.formPayment.complete_paid) / (+this.formPayment.total_payment / 100);
                if(! per){ per = 0; }
                return per.toFixed(2);
            },
            dialogPayment(){
                return this.$store.state.buyback.dialog_sale;
            },  

            transaction_id(){
                return this.$store.state.buyback.transaction_id;
            }
        },
    };
</script>
